import { CHURNER, FREE_TRIALER, MEMBER, NONE } from '../constants';
import { ICustomer } from '@monofront/types';

interface ITrackingPageType {
  value: string;
  exact?: string;
  regex?: RegExp;
  query?: { tab: string };
}

export const updateLocationSessionStorage = (currentLocation?: {
  location: string;
  expiresAt: number;
}) => {
  const date = new Date();

  const sessionLocation = {
    location:
      currentLocation?.expiresAt && currentLocation?.expiresAt < date.getTime()
        ? currentLocation?.location
        : document.location.protocol +
          '//' +
          document.location.hostname +
          document.location.pathname +
          document.location.search,
    expiresAt: date.setMinutes(date.getMinutes() + 30),
  };

  sessionStorage.setItem('originalLocation', JSON.stringify(sessionLocation));
};

export const getLocationFromSessionStorage = () => {
  return sessionStorage.getItem('originalLocation');
};

export const computeCustomerType = (
  customer?: Pick<ICustomer, 'omsTags'> | null,
) => {
  if (customer?.omsTags?.includes(CHURNER)) return CHURNER;
  if (customer?.omsTags?.includes(FREE_TRIALER)) return FREE_TRIALER;
  if (customer?.omsTags?.includes(MEMBER)) return MEMBER;

  return NONE;
};

const trackingPageTypes: ITrackingPageType[] = [
  {
    exact: '/',
    value: 'Home page',
  },
  {
    exact: '/home',
    value: 'Home page',
  },
  {
    exact: '/search',
    value: 'Search page',
  },
  {
    regex: /^\/collections\/(.*)$/,
    value: 'Collection page',
  },
  {
    regex: /^\/products\/(.*)$/,
    value: 'Product page',
  },
  { exact: '/cart', value: 'Cart Page' },
  { exact: '/pages/notre-mission', value: 'Mission page' },
  { exact: '/pages/unsere-mission', value: 'Mission page' },
  { exact: '/pages/comment-ca-marche', value: 'How it works page' },
  { exact: '/pages/wie-das-funktioniert', value: 'How it works page' },
  { exact: '/pages/la-livraison', value: 'Shipping page' },
  { exact: '/pages/die-lieferung', value: 'Shipping page' },
  { regex: /^\/product-basket\/(.*)$/, value: 'Bundle page' },
  { regex: /^\/pages\/my-lists\/(.+)$/, value: 'Personal list page' },
  {
    exact: '/pages/my-lists',
    value: 'Usual products page',
    query: { tab: 'my-purchases' },
  },
  { exact: '/pages/my-lists', value: 'Wishlists page' },
  { exact: '/pages/manage-my-subscription', value: 'Account page' },
  { exact: '/products/carte-cadeau-abonnement', value: 'Product page' },
  { exact: '/account/register', value: 'Subscription page' },
  { exact: '/account/adresses', value: 'Account page' },
  { exact: '/pages/adhesion-validee', value: 'Subscription page' },
  { exact: '/pages/subscription-confirmation', value: 'Subscription page' },
  { exact: '/pages/order-again', value: 'Account page' },
  { exact: '/pages/adhesion-validee', value: 'Product page' },
  {
    exact: '/pages/engagements-selection-des-marques',
    value: 'Engagement page',
  },
  {
    exact: '/pages/engagements',
    value: 'Engagement page',
  },
  {
    exact: '/pages/versprechen',
    value: 'Engagement page',
  },
  { exact: '/pages/adhesion-offertes', value: 'Free membership page' },
  { exact: '/pages/patenschaft', value: 'Free membership page' },
  { exact: '/pages/regimes-et-valeurs', value: 'Values page' },
  { exact: '/pages/bewusster-genuss', value: 'Values page' },
  { exact: '/pages/referral', value: 'Referral page' },
  { exact: '/account/register', value: 'Register page' },
  { exact: '/account/login', value: 'Login page' },
  { exact: '/pages/paiement', value: 'Subscription page' },
  { exact: '/pages/subscription-payment', value: 'Subscription page' },
  { regex: /^\/account(\/.*)?/, value: 'Account page' },
  { exact: '/apps/private-label/home', value: 'Private label home page' },
  {
    exact: '/apps/private-label/draft-product',
    value: 'Private label survey home page',
  },
  {
    exact: '/apps/private-label/product-polling',
    value: 'Private label next products survey page',
  },
  {
    exact: '/apps/private-label/result',
    value: 'Private label results home page',
  },
  {
    regex: /^\/apps\/private-label\/draft-product\/(.*)$/,
    value: 'Private label survey page',
  },
  {
    regex: /^\/apps\/private-label\/result\/(.*)$/,
    value: 'Private label results page',
  },
  { regex: /^\/account(\/.*)?/, value: 'Account page' },
  {
    exact: '/account/review-products',
    value: 'Product reviews page',
  },
  { regex: /^\/checkout(\/.*)?/, value: 'Checkout page' },
];

export const computeTrackingPageType = (url: string): string => {
  const [path, queryParams] = url.split('?');
  const searchParams = new URLSearchParams(queryParams);

  const found = trackingPageTypes.find((type) => {
    let queryIsValid = true;

    if (type.query && Object.keys(type.query).length > 0) {
      Object.entries(type.query).forEach(([key, value]) => {
        queryIsValid =
          queryIsValid &&
          searchParams.has(key) &&
          searchParams.get(key) === value;
      });
    }

    if ('exact' in type) {
      return type.exact === path && queryIsValid;
    }

    if ('regex' in type) {
      return type.regex?.test(path);
    }

    return false;
  });

  return found?.value || 'Other';
};
